import React from 'react';
import { FacebookIcon, PhoneIcon } from 'lucide-react';
interface FooterProps {
  setPage: (page: string) => void;
}
export function Footer({
  setPage
}: FooterProps) {
  return <footer className="bg-steel-950 text-steel-300 pt-16 pb-8 border-t-4 border-brand-red" itemScope itemType="https://schema.org/LocalBusiness" data-id="element-21">
      <meta itemProp="name" content="Merem Mobile Dustless Blasting Michigan, LLC" data-id="element-22" />
      <meta itemProp="telephone" content="(517) 777-8088" data-id="element-23" />

      <div className="max-w-7xl mx-auto px-4" data-id="element-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-25">
          {/* Col 1: Brand */}
          <div data-id="element-26">
            <div className="mb-6" data-id="element-27">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.meremblasting.com/uploaded/images/Misc%20icons%20and%20images/logo.png" alt="Merem Blasting" className="h-16 w-auto" data-id="element-28" />
            </div>
            <p className="text-sm mb-6 max-w-xs" itemProp="description" data-id="element-29">
              Professional mobile dustless and dry blasting services across
              Michigan. Fast turnaround, low mess, and exceptional results.
            </p>
            <a href="tel:5177778088" className="flex items-center text-white font-bold text-lg hover:text-brand-red transition-colors" data-id="element-30">
              <PhoneIcon className="w-5 h-5 mr-3 text-brand-red" data-id="element-31" />
              (517) 777-8088
            </a>
          </div>

          {/* Col 2: Services */}
          <div data-id="element-32">
            <h3 className="font-heading font-bold text-xl text-white uppercase tracking-wider mb-6" data-id="element-33">
              Services
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-34">
              <li data-id="element-35">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-36">
                  Dustless Blasting
                </button>
              </li>
              <li data-id="element-37">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-38">
                  Dry Blasting
                </button>
              </li>
              <li data-id="element-39">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-40">
                  Automotive Restoration
                </button>
              </li>
              <li data-id="element-41">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-42">
                  Heavy Equipment Cleaning
                </button>
              </li>
              <li data-id="element-43">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-44">
                  Graffiti Removal
                </button>
              </li>
              <li data-id="element-45">
                <button onClick={() => setPage('services')} className="hover:text-white transition-colors" data-id="element-46">
                  Concrete & Brick Restoration
                </button>
              </li>
              <li className="pt-2" data-id="element-47">
                <button onClick={() => setPage('services-hub')} className="text-brand-red hover:text-brand-red-light transition-colors font-semibold" data-id="element-48">
                  View All Services →
                </button>
              </li>
            </ul>
          </div>

          {/* Col 3: Company */}
          <div data-id="element-49">
            <h3 className="font-heading font-bold text-xl text-white uppercase tracking-wider mb-6" data-id="element-50">
              Company
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-51">
              <li data-id="element-52">
                <button onClick={() => setPage('about')} className="hover:text-white transition-colors" data-id="element-53">
                  About Us
                </button>
              </li>
              <li data-id="element-54">
                <button onClick={() => setPage('contact')} className="hover:text-white transition-colors" data-id="element-55">
                  Contact & Quotes
                </button>
              </li>
              <li data-id="element-56">
                <button onClick={() => setPage('resources')} className="hover:text-white transition-colors" data-id="element-57">
                  Resources & FAQ
                </button>
              </li>
              <li data-id="element-58">
                <button onClick={() => setPage('privacy')} className="hover:text-white transition-colors" data-id="element-59">
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>

          {/* Col 4: Service Areas */}
          <div data-id="element-60">
            <h3 className="font-heading font-bold text-xl text-white uppercase tracking-wider mb-6" data-id="element-61">
              Service Areas
            </h3>
            <ul className="space-y-3 text-sm mb-6" data-id="element-62">
              <li data-id="element-63">
                <button onClick={() => setPage('location')} className="hover:text-white transition-colors" data-id="element-64">
                  Detroit Metro
                </button>
              </li>
              <li data-id="element-65">
                <button onClick={() => setPage('location')} className="hover:text-white transition-colors" data-id="element-66">
                  Lansing / East Lansing
                </button>
              </li>
              <li data-id="element-67">
                <button onClick={() => setPage('location')} className="hover:text-white transition-colors" data-id="element-68">
                  Grand Rapids
                </button>
              </li>
              <li data-id="element-69">Fowlerville (HQ)</li>
              <li className="text-brand-red font-semibold" data-id="element-70">All of Michigan</li>
            </ul>
            <a href="https://www.facebook.com/meremblasting/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-steel-300 hover:text-white transition-colors" aria-label="Visit our Facebook page" data-id="element-71">
              <FacebookIcon className="w-6 h-6 mr-2" data-id="element-72" />
              <span className="text-sm font-medium" data-id="element-73">Follow on Facebook</span>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-steel-800 flex flex-col md:flex-row justify-between items-center text-xs text-steel-500 space-y-4 md:space-y-0" data-id="element-74">
          <p data-id="element-75">
            © {new Date().getFullYear()} Merem Mobile Dustless Blasting
            Michigan, LLC. All rights reserved.
          </p>
          <p data-id="element-76">Fowlerville, Michigan — Serving All of Michigan</p>
        </div>
      </div>
    </footer>;
}